import React from 'react';

import { Button as AntdButton } from 'antd';
import { DefaultOptionType } from 'antd/lib/select';

import {
  BrancheDto,
  FicheJudiciaireRequestDtoValeurJuridiqueEnum,
  FicheJudiciaireViolationDtoFormFieldEnum,
} from 'lib_api/lib/api/gen';

import BaseForm from 'components/BaseForm/BaseForm';
import BaseInputNumber from 'components/BaseForm/BaseInputNumber';
import BaseSelect from 'components/BaseForm/Select/BaseSelect';
import BaseSelectJuridiction from 'components/BaseForm/Select/juridiction/BaseSelectJuridiction';
import { useEnvironnement } from 'hooks/EnvironementStoreContext';
import { valeurJuridiqueMapping } from 'utils/enumData';
import { isJusticeFieldRequiredByBranche } from 'utils/justice/methods';

import { FicheInfractionFormValues, FicheJudiciaireFormValues } from '../types';

import { useValidateFicheJudiciaireField } from './utils';

interface FicheJudiciaireFormProps {
  goNextForm: () => void;
  goPreviousForm: () => void;
  initialValues: FicheJudiciaireFormValues;
  setValues: (newData: FicheJudiciaireFormValues) => void;
  motifMefId?: FicheInfractionFormValues['idMotifMef'];
  branche?: BrancheDto;
}

export default function FicheJudiciaireForm({
  goNextForm,
  goPreviousForm,
  initialValues,
  setValues,
  motifMefId,
  branche,
}: FicheJudiciaireFormProps): React.ReactElement {
  const validateField = useValidateFicheJudiciaireField(motifMefId || null);
  const [{ JUSTICE_ACTIVE_BOOL }] = useEnvironnement();

  return (
    <BaseForm
      initialValues={initialValues}
      onChange={(_changed, all) => {
        setValues(all);
        return all;
      }}
      validateField={validateField}
      inputs={[
        {
          label: 'Juridiction',
          name: 'juridiction',
          required: isJusticeFieldRequiredByBranche(
            JUSTICE_ACTIVE_BOOL,
            branche,
          ),
          field:
            FicheJudiciaireViolationDtoFormFieldEnum.ID_CORRELATION_JURIDICTION,
          render: () => <BaseSelectJuridiction />,
        },
        {
          label: 'N° de Parquet',
          name: 'numeroParquet',
          field: FicheJudiciaireViolationDtoFormFieldEnum.NUMERO_PARQUET,
          render: () => <BaseInputNumber />,
        },
        {
          label: 'N° de PV',
          name: 'numeroPv',
          field: FicheJudiciaireViolationDtoFormFieldEnum.NUMERO_PV,
        },
        {
          label: 'N° IDJ',
          name: 'numeroIDJ',
          field: FicheJudiciaireViolationDtoFormFieldEnum.NUMERO_IDJ,
        },
        {
          label: 'Valeur juridique',
          name: 'valeurJuridique',
          field: FicheJudiciaireViolationDtoFormFieldEnum.VALEUR_JURIDIQUE,
          render: () => {
            const options: DefaultOptionType[] = Object.keys(
              FicheJudiciaireRequestDtoValeurJuridiqueEnum,
            ).map(key => ({
              label:
                valeurJuridiqueMapping[
                  key as FicheJudiciaireRequestDtoValeurJuridiqueEnum
                ],
              value: key,
            }));

            return (
              <BaseSelect
                options={options}
                getOptionValue={option => option.value as string}
                getOptionLabel={option => option.label}
              />
            );
          },
        },
      ]}
      onSubmit={values => {
        setValues(values);
        goNextForm();
      }}
      submitText="Suivant"
      renderButtonAction={SubmitButton => {
        return (
          <div className="navigation">
            <AntdButton
              type={'primary'}
              className={'left'}
              onClick={goPreviousForm}
            >
              Précédent
            </AntdButton>
            <div className="right">{SubmitButton}</div>
          </div>
        );
      }}
    />
  );
}
